module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/readable-stream/duplex.js
// module id = ../../../../readable-stream/duplex.js
// module chunks = 3